import _ from "lodash";

export default class RecipientHelper {
  constructor(conversation) {
    this.conversation = conversation;

    this.recipients = [];

    this.build();
  }

  getRecipients() {
    return this.recipients;
  }

  build() {
    const recipients = _.get(this.conversation, "recipients.items") || [];
    this.recipients = recipients
      // .map(recipient => recipient.item)
      .filter((recipient) => {
        if (recipient.contact) {
          let list = _.filter(this.conversation.item.reshares, {
            to: [{ id: recipient.contact.id }],
          });
          return list.length == 0;
        }
        return true;
      })
      .map((recipient) => {
        return {
          item: recipient,
          children: [],
        };
      });

    if (this.recipients.length == 0) {
      this.recipients = recipients.map((recipient) => {
        return {
          item: recipient,
          children: [],
        };
      });
    }

    this.recipients.forEach((recipient) => {
      this.buildTreeForRecipient(recipient, []);
    });
  }

  buildTreeForRecipient(node, path) {
    var reshares = this.conversation.item.reshares.find((reshare) => {
      if (node.item.contact) {
        return node.item.contact.id === reshare.from.id;
      }
      return false;
    });

    if (!reshares) {
      return;
    }

    const recipients = _.get(this.conversation, "recipients.items") || [];
    var children = recipients
      .filter((recipient) => {
        if (recipient.contact != null) {
          return _.find(reshares.to, { id: recipient.contact.id }) != null;
        }
        return false;
      })
      .filter((recipient) => {
        return !this.isRecursivePath(path, recipient.contact.id);
      })
      .map((recipient) => {
        path = [...path, recipient.contact.id];

        return {
          item: recipient,
          children: [],
        };
      });

    node.children = children;

    node.children.forEach((child) => {
      this.buildTreeForRecipient(child, path);
    });
  }

  isRecursivePath(path, id) {
    return path.includes(id);
  }
}
